import React, { useMemo } from "react";
import IconStarFilledThin from "../../mui/JSXIcons/IconStarFilledThin";
import IconStarSimpleThin from "../../mui/JSXIcons/IconStarSimpleThin";
import CircleInfo from "../../mui/circle-info/CircleInfo";
import { useTranslation } from "react-i18next";
import "./jackpot.scss";

export default function JackpotContent({
  currency,
  decimal,
  grand,
  major,
  mini,
  jackpot,
  totalJackpotBalance
}) {
  const { t } = useTranslation();

  const cards = useMemo(() => {
    const getTitle = ({ minBet, depositDays, minDeposit }) => {
      if (minDeposit) {
        return t(
          "the minimum total bet in the game to qualify for this jackpot and the minimum deposit",
          {
            minBet: minBet,
            currency: currency,
            depositDays: depositDays | "any",
            minDeposit
          }
        );
      }

      return t("the minimum total bet in the game to qualify for this jackpot.", {
        minBet: minBet,
        currency: currency
      });
    };

    const grandCard = {
      title: "Grand Jackpot",
      dop: getTitle(grand),
      balance: grand?.amount?.toFixed(decimal)
    };

    const majorCard = {
      title: "Major Jackpot",
      dop: getTitle(major),
      balance: major?.amount?.toFixed(decimal)
    };

    const miniCard = {
      title: "Mini Jackpot",
      dop: getTitle(mini),
      balance: mini?.amount?.toFixed(decimal)
    };

    const cards = [];

    if (grand?.amount) cards.push(grandCard);
    if (major?.amount) cards.push(majorCard);
    if (mini?.amount) cards.push(miniCard);

    return cards;
  }, [jackpot, currency, decimal]);

  return (
    <div className="jackpot">
      <div className="jackpot__main">
        <span className="jackpot__main__title">
          {t("Total jackpot")} <IconStarFilledThin />
        </span>
        <span className="jackpot__main__balance">
          <span className="jackpot__main__balance__value">{totalJackpotBalance}</span>
          <span className="jackpot__main__balance__currency">{currency}</span>
          <IconStarSimpleThin />
        </span>
      </div>
      <div className="jackpot__cards">
        {cards.map((card, indx) => (
          <div key={indx} className="jackpot__card">
            <span className="jackpot__card__title">
              {card.title}
              <CircleInfo info={card.dop} />
            </span>
            <span className="jackpot__card__balance">
              <span className="jackpot__card__balance__value">{card.balance}</span>
              <span className="jackpot__card__balance__current">{currency}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
